<template>
  <div class="register-page">
    <div class="bg-shapes">
      <div class="shape shape-1"></div>
      <div class="shape shape-2"></div>
      <div class="shape shape-3"></div>
      <div class="shape shape-4"></div>
    </div>

    <div class="card">
      <div class="card-top">
        <div class="brand-icon">
          <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
            <rect x="3" y="7" width="30" height="22" rx="5" stroke="#fb7185" stroke-width="2" opacity="0.35" />
            <rect x="7" y="11" width="22" height="14" rx="3" stroke="#fb7185" stroke-width="2" />
            <circle cx="18" cy="18" r="3" fill="#fb7185" opacity="0.8" />
            <line x1="18" y1="15" x2="18" y2="21" stroke="#fb7185" stroke-width="1.5" opacity="0.5" />
            <line x1="15" y1="18" x2="21" y2="18" stroke="#fb7185" stroke-width="1.5" opacity="0.5" />
          </svg>
        </div>
        <h1 class="brand-name">创建账号</h1>
        <p class="brand-desc">注册酷度物联网平台</p>
      </div>

      <div class="form-body">
        <div class="input-group">
          <label class="input-label">手机号</label>
          <div class="input-wrap">
            <van-field v-model="phone" clearable type="number" placeholder="请输入手机号" input-class="field-input"
              maxlength="11" />
          </div>
        </div>

        <div class="input-group">
          <label class="input-label">短信验证码</label>
          <div class="input-wrap input-wrap-code">
            <van-field v-model="smscode" clearable type="number" placeholder="输入验证码" input-class="field-input"
              maxlength="6">
              <template #button>
                <button class="code-btn" :class="{ 'code-btn--disabled': countdown > 0 }"
                  :disabled="countdown > 0 || !phone" @click="sendsmscode">
                  {{ countdown > 0 ? countdown + 's' : '获取验证码' }}
                </button>
              </template>
            </van-field>
          </div>
        </div>

        <div class="input-group">
          <label class="input-label">设置密码</label>
          <div class="input-wrap">
            <van-field v-model="password" :type="showPwd ? 'text' : 'password'" clearable placeholder="6-20位字母或数字"
              input-class="field-input" :right-icon="showPwd ? 'eye-o' : 'closed-eye'"
              @click-right-icon="showPwd = !showPwd" />
          </div>
        </div>

        <div class="input-group">
          <label class="input-label">确认密码</label>
          <div class="input-wrap">
            <van-field v-model="repassword" :type="showRePwd ? 'text' : 'password'" clearable placeholder="再次输入密码"
              input-class="field-input" :right-icon="showRePwd ? 'eye-o' : 'closed-eye'"
              @click-right-icon="showRePwd = !showRePwd" />
          </div>
        </div>
      </div>

      <div class="agree-row" @click="agreed = !agreed">
        <div class="agree-checkbox">
          <svg v-if="agreed" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <rect width="18" height="18" rx="4" fill="#fb7185" />
            <path d="M5 9L7.5 11.5L13 6" stroke="white" stroke-width="1.8" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
          <svg v-else width="18" height="18" viewBox="0 0 18 18" fill="none">
            <rect x="0.5" y="0.5" width="17" height="17" rx="3.5" stroke="#d1d5db" fill="white" />
          </svg>
        </div>
        <span class="agree-text">我已阅读并同意</span>
        <span class="agree-link" @click.stop="showPrivacy = true">《隐私政策》</span>
      </div>

      <button class="submit-btn" @click="register" :disabled="loading || !agreed">
        <span v-if="!loading">注 册</span>
        <span v-else class="btn-loading"></span>
      </button>

      <div class="link-row">
        <span class="link-text">已有账户？</span>
        <span class="link-action" @click="gotologin">去登录</span>
      </div>
    </div>

    <van-popup v-model="showPrivacy" position="bottom" :style="{ height: '80%' }" closeable round>
      <div class="privacy-content">
        <h1>酷度物联网平台隐私政策</h1>

        <div class="privacy-meta">
          <p>更新日期：2026年3月25日</p>
          <p>生效日期：2026年3月25日</p>
        </div>

        <p class="privacy-intro">
          欢迎使用酷度智能硬件平台（以下简称"本平台"或"我们"）提供的服务。我们深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。本隐私政策旨在向您说明，我们如何收集、使用、存储、保护您的个人信息，以及您所享有的权利。
        </p>

        <div class="privacy-highlight">
          <p>请您在使用本平台服务前，仔细阅读并充分理解本隐私政策。如您不同意本政策内容，请勿注册或使用本平台服务。您的注册、登录或使用行为，即视为您已阅读并同意本政策的全部内容。</p>
        </div>

        <hr>

        <h2>一、适用范围</h2>
        <p>本隐私政策适用于酷度物联网平台提供的所有服务，包括但不限于：</p>
        <ul>
          <li>官方网站（网页端）</li>
          <li>微信小程序</li>
          <li>移动应用程序（APP）</li>
          <li>及与之连接的智能硬件设备</li>
        </ul>

        <hr>

        <h2>二、我们收集哪些信息</h2>
        <p>我们遵循合法、正当、必要和诚信的原则，仅收集与提供服务直接相关的个人信息。</p>

        <h3>（一）您主动提供的信息</h3>
        <ol>
          <li>
            <strong>手机号码</strong>
            <p>当您注册账号时，您需要提供手机号码。该手机号码仅用于以下目的：</p>
            <ul>
              <li>作为您的唯一登录账号</li>
              <li>在您忘记密码时，接收短信验证码以完成身份验证</li>
            </ul>
            <div class="privacy-highlight">
              <p>我们承诺：不会将您的手机号用于营销推广、用户画像、数据出售或向第三方共享等超出上述范围的用途，法律法规另有规定的情形除外。</p>
            </div>
          </li>
        </ol>

        <h3>（二）微信小程序特定收集的信息</h3>
        <p>当您通过微信小程序使用本平台服务时，我们可能从腾讯公司获取以下信息（需您授权）：</p>
        <ul>
          <li><strong>微信头像、昵称</strong>：用于快速完成注册或登录，并展示您的个人身份</li>
          <li><strong>微信 OpenID、UnionID</strong>：用于实现微信账号与本平台账号的绑定，保障您使用一键登录功能</li>
          <li><strong>手机号</strong>（如您授权）：部分情况下，您可通过微信授权获取已绑定的手机号，简化注册流程</li>
        </ul>
        <p>您可以在微信的"设置-个人信息与权限-授权管理"中管理或撤销上述授权。</p>

        <h3>（三）我们自动收集的信息</h3>
        <p>在您使用本平台服务过程中，我们可能自动收集以下信息，用于保障服务正常运行、优化用户体验：</p>
        <ol>
          <li>
            <strong>设备信息</strong>
            <p>包括设备型号、操作系统版本、设备唯一标识符（如IMEI、Android ID）、MAC地址等，用于设备连接与安全校验。</p>
          </li>
          <li>
            <strong>日志信息</strong>
            <p>包括您使用本平台的时间、操作记录、IP地址等，用于服务稳定性分析和异常排查。</p>
          </li>
          <li>
            <strong>智能设备相关信息</strong>
            <p>当您连接智能设备时，我们可能收集设备ID、设备名称、在线状态、固件版本等基本信息。</p>
          </li>
          <li>
            <strong>网络连接信息</strong>
            <p>如Wi-Fi名称（SSID），用于设备配网，不收集Wi-Fi密码。</p>
          </li>
        </ol>

        <h3>（四）微信小程序权限申请说明</h3>
        <p>为提供完整的智能设备连接与控制功能，当您通过微信小程序使用时，我们可能会向您申请以下系统权限：</p>
        <table>
          <thead>
            <tr>
              <th>权限类型</th>
              <th>用途说明</th>
              <th>是否可拒绝</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>蓝牙权限</td>
              <td>用于搜索、连接附近的蓝牙智能设备，实现设备添加与控制</td>
              <td>是，但拒绝后将无法使用蓝牙相关设备功能</td>
            </tr>
            <tr>
              <td>位置权限</td>
              <td>用于获取Wi-Fi列表、辅助蓝牙设备发现（Android系统要求必须授予位置权限才能扫描蓝牙设备）</td>
              <td>是，但拒绝后将无法使用蓝牙配网功能</td>
            </tr>
            <tr>
              <td>微信授权信息</td>
              <td>用于快捷登录、获取头像昵称</td>
              <td>是，但需手动填写手机号完成注册</td>
            </tr>
          </tbody>
        </table>
        <p>您可以在微信"发现-小程序-右上角菜单-设置"中随时关闭已授权的权限。关闭后仅影响对应功能，不影响您使用其他服务。</p>

        <h3>（五）不收集的信息</h3>
        <div class="privacy-highlight">
          <p>本平台不收集您的敏感个人信息（如身份证号码、银行账号、生物识别信息、行踪轨迹等），除非您另行明确授权或法律法规另有规定。</p>
        </div>

        <hr>

        <h2>三、我们如何使用您的信息</h2>
        <p>我们仅将收集的信息用于以下目的：</p>
        <ol>
          <li>提供账号注册、登录、身份验证服务</li>
          <li>实现智能设备连接、控制与管理</li>
          <li>保障平台及服务的稳定运行与安全</li>
          <li>响应用户的咨询、投诉及技术支持需求</li>
          <li>履行法律法规规定的义务</li>
        </ol>
        <div class="privacy-highlight">
          <p>我们承诺：不将您的个人信息用于个性化推荐、自动化决策或任何超出本政策声明的用途。</p>
        </div>

        <hr>

        <h2>四、信息存储与保护</h2>
        <h3>（一）存储地点</h3>
        <p>您的个人信息存储于中华人民共和国境内服务器。我们不会将您的个人信息传输至境外。</p>
        <h3>（二）存储期限</h3>
        <p>我们仅在实现本政策所述目的所必需的最短时间内保留您的个人信息。您注销账号后，我们将及时删除或匿名化处理您的个人信息。</p>
        <h3>（三）安全措施</h3>
        <p>我们采取符合行业标准的安全技术与管理措施，包括：</p>
        <ul>
          <li>数据加密存储与传输</li>
          <li>访问权限控制与审计</li>
          <li>定期安全检测与漏洞修复</li>
        </ul>

        <hr>

        <h2>五、信息共享与披露</h2>
        <h3>（一）共享</h3>
        <p>我们不会与任何第三方共享您的手机号码等个人信息，但以下情形除外：</p>
        <ol>
          <li>法律法规明确规定或司法机关、行政机关依法要求</li>
          <li>为维护国家安全、社会公共利益所必需</li>
          <li>在紧急情况下为保护您或他人生命财产安全所必需</li>
        </ol>
        <h3>（二）委托处理</h3>
        <p>我们可能委托第三方服务商（如短信验证码服务商）处理您的信息，该类委托方将仅在我们授权范围内提供服务，并承担相应的保密义务。</p>
        <h3>（三）与腾讯公司的信息交互</h3>
        <p>当您使用微信小程序时，我们与腾讯公司进行必要的信息交互，包括获取您授权的微信头像、昵称、OpenID等。该信息处理受腾讯公司相关协议（如《微信隐私保护指引》）约束，我们仅按本政策约定使用。</p>
        <h3>（四）公开披露</h3>
        <p>我们不会公开披露您的个人信息，除非获得您单独同意或法律法规另有规定。</p>

        <hr>

        <h2>六、您的权利</h2>
        <p>您对您的个人信息享有以下权利：</p>
        <ol>
          <li><strong>查阅与更正</strong>：您可通过平台查看您的手机号等基本信息，如有错误可联系客服更正。</li>
          <li><strong>注销账号</strong>：您可随时通过"个人中心"页面中的"账号注销"功能，或联系客服申请注销账号。我们将在核实身份后7个工作日内完成注销，并删除您的个人信息。</li>
          <li><strong>撤回同意</strong>：您可通过注销账号的方式撤回对本隐私政策的全部同意。</li>
          <li><strong>投诉与反馈</strong>：如您认为您的个人信息权益受到侵害，可通过第八条所述联系方式联系我们。</li>
        </ol>

        <hr>

        <h2>七、未成年人保护</h2>
        <p>本平台服务主要面向成年人。如您未满18周岁，请在监护人陪同下阅读并决定是否使用本平台服务。若您是未成年人监护人，并对被监护人的信息处理有疑问，可通过本政策联系方式与我们沟通。</p>

        <hr>

        <h2>八、联系方式</h2>
        <p>如您对本隐私政策有任何疑问、意见或建议，或需要行使您的权利，可通过以下方式联系我们：</p>
        <div class="privacy-contact">
          <p><strong>客服热线：0554-6673738</strong></p>
          <p>我们将在15个工作日内核实并处理您的请求</p>
        </div>

        <hr>

        <h2>九、政策变更</h2>
        <p>我们可能根据法律法规变化或服务需要更新本隐私政策。如发生重大变更，我们将通过平台公告、弹窗提示等方式通知您。您继续使用本平台服务即视为同意更新后的政策。</p>

        <hr>

        <h2>十、法律适用与争议解决</h2>
        <p>本隐私政策适用中华人民共和国法律。因本政策引发的争议，双方应友好协商解决；协商不成的，任何一方均可向本平台运营方住所地有管辖权的人民法院提起诉讼。</p>

        <hr>

        <h2>附：短信验证码服务特别提示</h2>
        <p>短信验证码的发送与接收依赖于电信运营商网络。如因运营商网络故障、信号延迟、短信拦截、手机停机等原因导致验证码未送达或延迟，平台不承担相应责任。请您确保所填手机号真实有效、状态正常，并保持通信畅通。</p>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'register',
  data() {
    return {
      phone: '',
      password: '',
      repassword: '',
      smscode: '',
      showPwd: false,
      showRePwd: false,
      agreed: false,
      showPrivacy: false,
      loading: false,
      countdown: 0,
      timer: null
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  methods: {
    gotologin() {
      this.$router.push({ name: 'login' });
    },
    sendsmscode() {
      if (this.countdown > 0) return;
      if (!this.phone || this.phone.length < 11) {
        this.$toast.fail('请输入正确的手机号');
        return;
      }
      const qs = require('qs');
      this.$axios.post('/api/user/sms', qs.stringify({ 'phone': this.phone, 'check': "1234" }))
        .then((response) => {
          if (response.data.error_code === 0) {
            this.$toast.success('获取短信验证码成功');
            this.countdown = 60;
            this.timer = setInterval(() => {
              this.countdown--;
              if (this.countdown <= 0) {
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          } else if (response.data.error_code === 205) {
            this.$toast.fail('短信已发送，获取短信间隔过短！');
          } else {
            this.$toast.fail('获取短信验证码失败！');
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    register() {
      if (!this.agreed) {
        this.$dialog.alert({
          title: '隐私政策',
          message: '为了更好的保护您的权益，同时遵守相关监管要求，请认真阅读《隐私政策》',
        });
        return;
      }
      if (!this.phone || !this.password || !this.repassword || !this.smscode) {
        this.$toast.fail('请填写完整信息');
        return;
      }
      if (this.password !== this.repassword) {
        this.$toast.fail('2次密码输入不一致！');
        return;
      }
      this.loading = true;
      const qs = require('qs');
      this.$axios.post('/api/user/register', qs.stringify({
        'password': this.password,
        'repassword': this.repassword,
        'sms_check': this.smscode
      }))
        .then((response) => {
          this.loading = false;
          if (response.data.error_code === 0) {
            this.$router.push({ path: "/login", name: "login" });
            //this.$router.push({ path: '/', name: '设备主页', query: { gid: [''] } });
          } else if (response.data.error_code === 201) {
            this.$toast.fail('此手机号已经被注册！');
          } else if (response.data.error_code === 206) {
            this.$toast.fail('短信验证码错误！');
          }
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
        });
    }
  }
}
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Noto+Sans+SC:wght@400;500;600;700&display=swap");
</style>

<style scoped>
.register-page {
  min-height: 100vh;
  min-height: 100dvh;
  background: linear-gradient(145deg, #fdf2f8 0%, #fff7ed 35%, #f0f9ff 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  box-sizing: border-box;
  font-family: "Inter", "Noto Sans SC", sans-serif;
  position: relative;
  overflow: hidden;
}

.bg-shapes {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 0;
}

.shape {
  position: absolute;
  border-radius: 50%;
}

.shape-1 {
  width: 300px;
  height: 300px;
  background: radial-gradient(circle, rgba(251, 113, 133, 0.1) 0%, transparent 70%);
  top: -100px;
  right: -40px;
  animation: shapeDrift 19s ease-in-out infinite alternate;
}

.shape-2 {
  width: 240px;
  height: 240px;
  background: radial-gradient(circle, rgba(251, 191, 36, 0.07) 0%, transparent 70%);
  bottom: -30px;
  left: -60px;
  animation: shapeDrift 17s ease-in-out infinite alternate-reverse;
}

.shape-3 {
  width: 200px;
  height: 200px;
  background: radial-gradient(circle, rgba(167, 139, 250, 0.06) 0%, transparent 70%);
  top: 40%;
  right: -50px;
  animation: shapeDrift 21s ease-in-out infinite alternate;
}

.shape-4 {
  width: 160px;
  height: 160px;
  background: radial-gradient(circle, rgba(45, 212, 191, 0.05) 0%, transparent 70%);
  bottom: 30%;
  left: -30px;
  animation: shapeDrift 15s ease-in-out infinite alternate-reverse;
}

@keyframes shapeDrift {
  0% {
    transform: translate(0, 0) scale(1);
  }

  100% {
    transform: translate(25px, -15px) scale(1.08);
  }
}

.card {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 400px;
  background: #ffffff;
  border-radius: 28px;
  padding: 36px 32px 32px;
  box-shadow: 0 4px 32px rgba(0, 0, 0, 0.04), 0 20px 60px rgba(0, 0, 0, 0.06);
  animation: cardSlide 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

@keyframes cardSlide {
  from {
    opacity: 0;
    transform: translateY(24px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.card-top {
  text-align: center;
  margin-bottom: 24px;
}

.brand-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}

.brand-name {
  font-weight: 700;
  font-size: 22px;
  color: #1e293b;
  margin: 0 0 4px;
  letter-spacing: 0.5px;
}

.brand-desc {
  font-size: 13px;
  color: #94a3b8;
  margin: 0;
  font-weight: 400;
}

.form-body {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 16px;
}

.input-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.input-label {
  font-size: 13px;
  font-weight: 500;
  color: #475569;
  padding-left: 2px;
}

.input-wrap :deep(.van-cell) {
  background: #f8fafc;
  border: 2px solid #e2e8f0;
  border-radius: 14px;
  padding: 10px 16px;
  transition: border-color 0.25s, box-shadow 0.25s, background 0.25s;
  min-height: 46px;
}

.input-wrap :deep(.van-cell:focus-within) {
  border-color: #fb7185;
  background: #ffffff;
  box-shadow: 0 0 0 4px rgba(251, 113, 133, 0.08);
}

.input-wrap :deep(.van-field__body) {
  background: transparent;
}

.field-input {
  color: #1e293b !important;
  font-size: 15px !important;
  font-weight: 500 !important;
  background: transparent !important;
}

.input-wrap :deep(.van-field__placeholder) {
  color: #cbd5e1 !important;
  font-weight: 400 !important;
}

.input-wrap :deep(.van-field__right-icon) {
  color: #94a3b8;
  font-size: 18px;
}

.input-wrap-code :deep(.van-cell) {
  padding-right: 4px;
}

.code-btn {
  flex-shrink: 0;
  height: 36px;
  padding: 0 16px;
  border: none;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  background: linear-gradient(135deg, #fb7185, #f43f5e);
  color: #fff;
  transition: opacity 0.2s, transform 0.15s;
  font-family: inherit;
}

.code-btn:active {
  transform: scale(0.95);
}

.code-btn--disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.agree-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 20px;
  cursor: pointer;
  padding: 2px 0;
}

.agree-checkbox {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.agree-text {
  font-size: 13px;
  color: #94a3b8;
}

.agree-link {
  font-size: 13px;
  color: #fb7185;
  font-weight: 500;
  cursor: pointer;
}

.submit-btn {
  display: block;
  width: 100%;
  height: 50px;
  border: none;
  border-radius: 14px;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 3px;
  cursor: pointer;
  color: #fff;
  background: linear-gradient(135deg, #fb7185 0%, #f43f5e 100%);
  box-shadow: 0 4px 16px rgba(251, 113, 133, 0.3);
  transition: transform 0.2s, box-shadow 0.2s;
  margin-bottom: 16px;
  font-family: inherit;
}

.submit-btn:active:not(:disabled) {
  transform: scale(0.97);
  box-shadow: 0 2px 8px rgba(251, 113, 133, 0.25);
}

.submit-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-loading {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.link-row {
  text-align: center;
  font-size: 14px;
}

.link-text {
  color: #94a3b8;
}

.link-action {
  color: #fb7185;
  font-weight: 500;
  cursor: pointer;
  margin-left: 4px;
}

.link-action:active {
  color: #e11d48;
}

.privacy-content {
  padding: 28px 20px 40px;
  font-family: "Noto Sans SC", sans-serif;
  color: #475569;
  font-size: 14px;
  line-height: 1.8;
  background: #fff;
  min-height: 100%;
}

.privacy-content h1 {
  font-size: 20px;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 16px;
  text-align: center;
}

.privacy-content h2 {
  font-size: 17px;
  font-weight: 600;
  color: #fb7185;
  margin: 24px 0 10px;
}

.privacy-content h3 {
  font-size: 15px;
  font-weight: 500;
  color: #334155;
  margin: 18px 0 8px;
}

.privacy-content p {
  margin: 0 0 10px;
}

.privacy-content ul,
.privacy-content ol {
  padding-left: 20px;
  margin: 8px 0 12px;
}

.privacy-content li {
  margin-bottom: 6px;
}

.privacy-content hr {
  border: none;
  border-top: 1px solid #f1f5f9;
  margin: 20px 0;
}

.privacy-meta {
  text-align: center;
  font-size: 12px;
  color: #94a3b8;
  margin-bottom: 20px;
}

.privacy-meta p {
  margin: 2px 0;
}

.privacy-intro {
  text-indent: 2em;
}

.privacy-highlight {
  background: #fff1f2;
  border-left: 3px solid #fb7185;
  padding: 10px 14px;
  border-radius: 0 8px 8px 0;
  margin: 12px 0;
}

.privacy-highlight p {
  margin: 0;
  font-size: 13px;
  color: #e11d48;
}

.privacy-content table {
  width: 100%;
  border-collapse: collapse;
  margin: 12px 0;
  font-size: 13px;
}

.privacy-content th {
  background: #fff1f2;
  color: #fb7185;
  padding: 8px 10px;
  text-align: left;
  font-weight: 500;
  border: 1px solid #fce7f3;
}

.privacy-content td {
  padding: 8px 10px;
  border: 1px solid #f1f5f9;
  color: #64748b;
}

.privacy-contact {
  background: #fff1f2;
  border: 1px solid #fecdd3;
  border-radius: 10px;
  padding: 14px 18px;
  text-align: center;
  margin: 12px 0;
}

.privacy-contact p {
  margin: 2px 0;
  color: #e11d48;
}
</style>
